import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=a4875e00&scoped=true&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=a4875e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4875e00",
  null
  
)

export default component.exports